import React from 'react'

const Cancelltion_refund_policy = () => {
  return (
    <div className="container my-5">
    <div className="card shadow border-0 p-4">
      <h2 className="text-center mb-4 fw-bold text-primary">
        Cancellation & Refund Policy
      </h2>
      <p className="text-muted mb-4">
        This policy explains how cancellations and refunds are handled at{" "}
        <strong>Dartex Technology Private Limited (Dartex)</strong>.
      </p>

      <section className="mb-4">
        <h5 className="fw-semibold">1. Order Cancellation</h5>
        <ul className="mt-2">
          <li>
            Once an order is booked and handed over to the courier partner, it
            cannot be cancelled.
          </li>
          <li>
            Sellers may cancel a booking before courier pickup, but shipping
            charges (if applied) are non-refundable.
          </li>
        </ul>
      </section>

      <section className="mb-4">
        <h5 className="fw-semibold">2. Refund of Shipping Charges</h5>
        <ul className="mt-2">
          <li>
            Shipping charges are generally non-refundable once service has
            been rendered.
          </li>
          <li>
            In case of system errors, duplicate charges, or technical issues,
            refunds may be processed after verification.
          </li>
        </ul>
      </section>

      <section className="mb-4">
        <h5 className="fw-semibold">3. COD Remittance Refunds</h5>
        <ul className="mt-2">
          <li>COD remittance will be processed as per agreed timelines.</li>
          <li>
            Refunds are not applicable for COD remittance delays caused by
            courier partners, banking issues, or incomplete Seller details.
          </li>
        </ul>
      </section>

      <section className="mb-4">
        <h5 className="fw-semibold">4. RTO & Undelivered Parcels</h5>
        <ul className="mt-2">
          <li>
            RTO shipments are chargeable. No refund of shipping or COD fees is
            applicable.
          </li>
        </ul>
      </section>

      <section className="mb-4">
        <h5 className="fw-semibold">5. Disputes</h5>
        <ul className="mt-2">
          <li>
            Any refund disputes must be raised within 7 working days of the
            transaction.
          </li>
          <li>
          Dartex decision on refund eligibility will be final.
          </li>
        </ul>
      </section>

      <p className="text-muted mt-4">
        By using Dartex services, you agree to this{" "}
        <strong>Cancellation & Refund Policy</strong>.
      </p>
    </div>
  </div>
  )
}

export default Cancelltion_refund_policy
